import { render, staticRenderFns } from "./CasinoLoginRestriction.vue?vue&type=template&id=18c9083c&scoped=true&"
import script from "./CasinoLoginRestriction.vue?vue&type=script&lang=js&"
export * from "./CasinoLoginRestriction.vue?vue&type=script&lang=js&"
import style0 from "./CasinoLoginRestriction.vue?vue&type=style&index=0&id=18c9083c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c9083c",
  null
  
)

export default component.exports